/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { customerSessionsCreate } from "../funcs/customerSessionsCreate.js";
import { ClientSDK } from "../lib/sdks.js";
import { unwrapAsync } from "../types/fp.js";
export class CustomerSessions extends ClientSDK {
    /**
     * Create Customer Session
     *
     * @remarks
     * Create a customer session.
     *
     * **Scopes**: `customer_sessions:write`
     */
    async create(request, options) {
        return unwrapAsync(customerSessionsCreate(this, request, options));
    }
}
//# sourceMappingURL=customersessions.js.map